// utils/normalizePhone.js
export const normalizePhone = (phone) => {
  if (!phone) return '';
  // حذف فاصله، خط تیره، پرانتز و کاراکترهای اضافی
  let cleaned = phone.replace(/[\s\-\(\)\+]/g, '');
  // اگر با 98+ یا 98 شروع شد، تبدیل به 0
  if (cleaned.startsWith('98')) {
    cleaned = '0' + cleaned.slice(2);
  }
  // اگر با 0 شروع نشد، 0 اضافه کن (برای شماره‌های 10 رقمی)
  if (!cleaned.startsWith('0') && cleaned.length === 10) {
    cleaned = '0' + cleaned;
  }
  return cleaned;
};